import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/pc/rhChatLog/page', data, {
    trim: true
  })
}
